import { ENGINE_STATUS } from '@modules/controladoria-v2/constants/Status'
import { DEFAULT_TAX_PARAMS } from '@modules/controladoria-v2/constants/taxParams'

// Neutral fallback map — mantém as 4 chaves para que os consumidores sempre
// encontrem a forma esperada. Não é exibido: a UI só mostra as pills quando
// `engineStatus.dataReferencia` bate com o fechamento atual (ver getter
// `engineStatusReady`); antes disso é skeleton.
const buildInitialEngineStatus = () => ({
  pj: { status: ENGINE_STATUS.NUNCA },
  fp: { status: ENGINE_STATUS.NUNCA },
  produto: { status: ENGINE_STATUS.NUNCA },
  dfc: { status: ENGINE_STATUS.NUNCA },
})

// `configDRE` agora começa vazio: cada aba é carregada do backend ao montar via
// apiControladoriaConfigDRE.carregar. Sem seed e sem localStorage (decisão #5
// do plano cat_lanc) — o backend é a fonte da verdade.
export const buildInitialState = () => ({
  fechamentos: {
    data: [],
  },
  fechamentoAtual: { dataReferencia: null },
  importacoes: {},
  importacoesDataReferencia: null,
  // Estado de processamento dos arquivos no dataroom, no slice padrão
  // `{ data, loading, lastUpdate }`. `data` é o mapa por tipo:
  // `{ [tipo]: { id, status, message, data_atualizacao } }`. Vem do endpoint de
  // status (polling) e é mesclado com `importacoes` (sumário) ao montar o card.
  dataroomStatus: {
    data: {},
    loading: false,
    lastUpdate: null,
  },
  configDRE: {},
  // Dicionário `{ campo: [valores] }` + a data_referencia a que ele pertence.
  // Como as opções de rateio incluem as listas do fechamento, o cache é
  // invalidado quando o mês muda (ver SET_FECHAMENTO_ATUAL).
  configDREDropdownOptions: {},
  configDREDropdownOptionsDataReferencia: null,
  listas: {
    data: [],
    dataReferencia: null,
    loading: false,
  },
  // Status dos motores no slice padrão + a `data_referencia` que o gerou. O
  // carimbo é o que separa "status deste mês" de "status do mês anterior ainda
  // na memória": ao trocar de fechamento o slice é invalidado (ver
  // SET_FECHAMENTO_ATUAL) e a UI mostra skeleton até a resposta do mês novo.
  // `error` guarda a mensagem da última falha de carga para a UI oferecer retry
  // em vez de shimmer infinito.
  engineStatus: {
    data: buildInitialEngineStatus(),
    loading: false,
    dataReferencia: null,
    error: null,
  },
  // Parâmetros de impostos da última rodagem do motor. Hidratado a partir do
  // `parametros_impostos` devolvido pelo status (GET /fechamentos/motor) e usado
  // para pré-selecionar os checkboxes do modal de confirmação de rodagem.
  taxParams: { ...DEFAULT_TAX_PARAMS },
  versoesPublicadas: 0,
})

export default buildInitialState()
